import gql from 'graphql-tag'

export const resourceUnavailabilityFragment = gql`
    fragment resourceUnavailabilityFragment on ResourceUnavailability{
        id
        # name
        date
        description
        rangeID
        resourceUnavailabilityTypeID
    }
`

export const resourceUnavailabilityTypeFragment = gql`
    fragment resourceUnavailabilityTypeFragment on ResourceUnavailabilityType{
        id
        name
        color
        label
        deleted_at
    }
`